<template>
  <div>
    <a-modal
        title="预警信息"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :footer="null"
        @cancel="handleCancel"
        width="800px"
    >
      <a-table
          bordered
          rowKey="message"
          :dataSource="dataSource"
          :pagination="pagination"
          :columns="columns"
          @change="change2"
          style="margin-top: 10px"
      >
        </a-table>
    </a-modal>
  </div>
</template>

<script>
  import { warningList} from "../../api/http";
  const columns = [
    {
      title: "预警内容",
      dataIndex: "message",
    },
    {
      title: "发布时间",
      dataIndex: "publicDate",
    }
  ];
export default {
  name: "warning",

  data() {
    return {
      columns,
      visible: false,
      confirmLoading: false,
      loading: false,
      uscc:"",
      pageNum:1,
      dataSource:[],
      pagination: {

      },
    }
  },
  methods: {
    afterClose() {
      this.dataSource = [];
    },
    change2(page) {
      this.pageNum = page.current;
      this.getData();
    },
    showmodal(uscc) {
      this.visible = true;
      this.uscc=uscc;
      this.getData();
    },
    getData(){
      warningList(this.pageNum,this.uscc)
          .then(res=>{
            this.dataSource=res.data.data.page.list;
            this.pagination = {
              current: res.data.data.page.pageNum,
              pageSize: res.data.data.page.pageSize,
              total: res.data.data.page.total
            };
          })

    },
    handleCancel() {
      this.visible = false;
      this.dataSource=[];
    },
  }
}
</script>

<style scoped>

</style>